module.exports = __webpack_public_path__ + "files/31f309479a8f575f86eeaf15ae4e5e33.svg";